<template>
  <div>
    <div v-if="raiz && mode == 'view' && value && value.length && !tem_valor(value)">
      <template v-if="!secundario">
        Nenhuma informação registrada.
      </template>
    </div>

    <!-- Formulário -->
    <div :class="( isTable ? '' : 'form-row ' ) + ( gutters ? '' : 'no-gutters' ) + ( tamanho == 'P' ? ' mb-1' : '' ) "
      :style="onecol ? 'display: contents; ' : ''"
      v-else-if="value && value.length">
      <template v-for="(campo, index) in value">
      <div :key="index" v-if="!campo.vs || visivel(campo)"
        :class="( isTable ? '' : 'col ' + ( printing ? ( 'col-' + campo.width ) : ( 'col-12 col-md-' + campo.width ) ) )
          + ( ( gutters || isTable ) ? '' : ( tamanho == 'P' ? '  pt-0 pb-1 px-1' : '  p-1' ) )
          + ( ( campo.color && !['group','list'].find(item => item == campo.type) ) ? ' alert-' + campo.color : '' )">

        <!-- Quebra de Página -->
        <template v-if="campo.type == 'page-break'">
          <hr>
        </template>

        <!-- Visibilidade condicionada de campo -->
        <template v-else-if="visivel(campo)">

          <!-- Grupo de Campos -->
          <div class="row" v-if="campo.type == 'group' && ( mode != 'view' || tem_valor(campo.campos) ) && ( show_boxes !== false || ( validate && mode != 'view' ) || campo.type != 'group' )">
            <div class="col col-12">
                <div class="card" :class="( ( campo.label && !gutters ) ? 'mt-2' : '' ) + ( gutters ? ' mb-1' : 'mb-1')">
                    <div class="card-header d-flex justify-content-between" :class="( campo.color ? 'alert-' + campo.color : '' ) + ( ( tamanho == 'P' || gutters ) ? ' py-0 px-2 ' : 'p-2' ) " v-if="campo.label">
                      <div>
                        <a href="#" class="card-link text-dark" @click.prevent="toggle_view_grupo(campo)">
                            <small class="card-title py-1 mb-0" v-if="tamanho == 'P'">{{ campo.label }}</small>
                            <div class="card-title mb-0" v-else-if="tamanho == 'M'">{{ campo.label }}</div>
                            <h5 class="card-title mb-0" v-else>{{ campo.label }}</h5>
                        </a>
                      </div>
                      <div v-if="campo.score">
                        <span v-if="( campo.aval || campo.aval === 0 ) && campo.av && campo.av.js_avaliacao && campo.av.js_avaliacao.length">
                          <span class="badge mr-2" :class="'badge-' + campo.av.js_avaliacao[campo.aval].cor">{{ campo.av.js_avaliacao[campo.aval].resultado }}</span>
                        </span>
                        <span class="badge badge-secondary" v-if="mode == 'view' && ( campo.sv || campo.sv === 0 )">{{ campo.sv }}</span>
                        <span class="badge badge-secondary" v-else-if="mode != 'view'">{{ calc_score(campo) }}</span>
                      </div>
                    </div>
                    <div class="card-body px-2 pt-2 pb-0">
                      <campos-formulario :gutters="gutters"
                        v-show="( campo.sh !== false ) || validate"
                        v-model="campo.campos"
                        :validate="validate"
                        :mode="mode"
                        :printing="printing"
                        :compact="compact"
                        :modelo="modelo"
                        :tamanho="tamanho"
                        :tamanhoform="tamanhoform"
                        :eh_filho="true"
                        :textos="textos"
                        @recalc="calc_computed" />
                    </div>
                </div>
            </div>
          </div>

          <!-- Tabela -->
          <div class="row" v-else-if="campo.type == 'tabela' && ( mode != 'view' || tem_valor(campo.campos) )">
            <div class="col col-12">
                <small class="form-text text-muted" v-if="campo.label">{{ campo.label }}</small>
                <table class="table table-sm table-bordered">
                  <thead>
                    <tr>
                      <th v-for="(col, cidx) in campo.cols.split(',')" :key="'col-' + cidx" :class="( col && col.slice(0,1) == ' ' ) ? 'text-right' : ''">
                        {{ col }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(linha, lidx) in agrupa_linhas(campo.campos, campo)" :key="'linha-' + lidx">
                      <td v-for="(col, cidx) in linha" :key="'col-' + cidx" :width="col.largura + '%'" :class="col.classes">
                        <campos-formulario
                          :isTable="true"
                          :gutters="gutters"
                          v-model="col.cols"
                          :validate="validate"
                          :mode="mode"
                          :modelo="modelo"
                          :printing="printing"
                          :tamanho="tamanho"
                          :tamanhoform="tamanhoform"
                          @recalc="calc_computed" />
                      </td>
                    </tr>
                  </tbody>
                </table>

                <pre v-if="false">{{ agrupa_linhas(campo.campos, campo) }}</pre>
            </div>
          </div>

          <!-- Lista -->
          <div class="row" v-else-if="campo.type == 'list' && ( mode != 'view' || ( campo.lista && campo.lista.length ) )">
            <div class="col col-12">
                <div class="card">
                    <div class="card-header" :class="( campo.color ? 'alert-' + campo.color : '' )" v-if="campo.label">
                      <small class="card-title mb-0" v-if="tamanho=='P'">{{ campo.label }}</small>
                      <h5 class="card-title mb-0" v-else>{{ campo.label }}</h5>
                    </div>
                    <ul class="list-group" v-if="campo.lista">
                      <li class="list-group-item" v-for="(itemlist, lidx) in campo.lista" :key="'lista-' + index + '-' + lidx">
                        <div class="row">
                          <div class="col col-auto" v-if="mode != 'view'">
                            <button type="button" class="btn btn-outline-danger btn-sm mr-2" @click="excluirItem(campo.lista, lidx)">
                              <i class="fas fa-minus"></i>
                            </button>
                          </div>
                          <div class="col col-11">
                            <campos-formulario
                              :gutters="gutters"
                              v-model="campo.lista[lidx]"
                              :validate="validate"
                              :mode="mode"
                              :islist="true"
                              :listindex="lidx"
                              :printing="printing"
                              :compact="compact"
                              :modelo="modelo"
                              :tamanho="tamanho"
                              :tamanhoform="tamanhoform" />
                          </div>
                        </div>
                      </li>
                    </ul>
                    <div class="card-footer" v-if="mode != 'view'">
                      <button type="button" class="btn btn-primary btn-sm" @click="incluirItemLista(campo)">
                        <i class="fas fa-plus"></i>
                      </button>
                    </div>
                </div>
            </div>
          </div>

          <!-- Título e Subtítulo -->
          <az-sub-title class="mt-1" :scrolltop="true" :color="campo.color" v-else-if="campo.type == 'title' || campo.type == 'subtitle'" :big="campo.type == 'title' && tamanho != 'P'" :title="campo.label"></az-sub-title>

          <!-- Labels -->
          <template v-else-if="campo.type == 'label'">
            <label :class="isTable ? 'mb-0' : ''">{{ campo.label }}</label>
          </template>

          <!-- Link -->
          <template v-else-if="campo.type == 'link'">
            <template v-if="mode != 'view'">
              <a :href="campo.value" target="_blank" v-if="( campo.value && campo.value.slice(0,4) == 'http' )">{{ campo.label }}</a>
              <span v-else>Link inválido. Deve iniciar com "http"</span>
            </template>
          </template>

          <!-- Audiograma -->
          <template v-else-if="campo.type == 'audiograma'">
            <audiograma :dados="grafico_audiograma(campo.ouvido)" :altura="400" />
          </template>

          <!-- Gráfico Pediatria -->
          <template v-else-if="campo.type == 'grafico-pediatria'">
            <grafico-crescimento
              :dados="{
                  tipo: ( campo.grafico ? campo.grafico : '2' ) + ( sexo_paciente ? sexo_paciente : 'M' ),
                  valorY: grafico_valorY(campo),
                  valorX: grafico_valorX(campo),
                  sexo: sexo_paciente,
                  linhas: [ { tipo: 'P3', cor: 'red'}, { tipo: 'P15', cor: 'orange'}, { tipo: 'P50', cor: 'green'}, { tipo: 'P85', cor: 'orange'}, { tipo: 'P97', cor: 'red'} ]
                }" />
          </template>

          <!-- Imitância Acústica -->
          <template v-else-if="campo.type == 'imitancia-acustica'">
            <imitancia-acustica :dados="grafico_imitancia()" :altura="400" />
          </template>

          <!-- Imagem Marcável -->
          <template v-else-if="campo.type == 'imagembase' && campo.id_arquivo">
            <div class="form-group" :class="tamanho == 'P' ? 'mb-0' : ( tamanho == 'M' ? ' mb-2' : '' )">
              <small class="form-text text-muted" v-if="!isTable && campo.label">{{ campo.label }}</small>
              <marcador-imagem
                :id="campo.id_arquivo"
                :tools="campo.marcs"
                :selected="campo.ms"
                :tamanho="campo.t ? campo.t : 200"
                v-model="campo.value" />

              <div class="card mb-0 mt-1" v-if="campo.marcs && campo.marcs.length > 1">
                <div class="card-body p-2">
                  <a href="#" v-for="(marc, imx) in campo.marcs" :key="imx" :title="marc.info" class="mr-2" @click.prevent="selecionar_imagem_tool(campo, imx)">
                    <i class="fa-solid fa-circle" aria-hidden="true" :style="'color: ' + marc.cor" v-if="imx == campo.ms"></i>
                    <i class="fa-solid fa-circle-dot" aria-hidden="true" :style="'color: ' + marc.cor" v-else></i>
                  </a>
                </div>
              </div>

              <pre v-if="false">{{ campo.value }}</pre>
            </div>
          </template>

          <!-- Campos -->
          <template v-else>
            <template v-if="mode == 'view'">
              <div class="form-group encurtar" :class="( isTable || tamanho == 'P' ) ? 'mb-0' : ( tamanho == 'M' ? ' mb-2' : '' )" v-if="( modelo && modelo.fl_view_vazio ) || ( campo.value && campo.value != '|' )">
                <small class="form-text text-muted" v-if="!isTable">{{ campo.label }}</small>
                <div class="quill-content" v-if="campo.type == 'rich'" v-html="campo.value"></div>
                <div v-else-if="campo.type == 'checkbox' || campo.type == 'checkbox-group'">
                  <i class="fas fa-check" v-if="campo.value"></i>
                  <i class="fa fa-minus" v-else></i>
                </div>
                <div class="text-dark" v-else-if="campo.type == 'number2' || campo.type == 'number'" style="white-space: pre-wrap;">
                  <span :class="size_class" v-if="campo.type == 'number2'">{{ campo.value.split('|').join('x') }}</span>
                  <span :class="size_class" v-else>{{ campo.value }}</span>
                  <small class="text-muted ml-1" v-if="campo.um">{{ campo.um }}</small>
                </div>
                <div :class="size_class" class="text-dark" v-else-if="campo.type == 'date'">
                  <span v-if="campo.value">
                    {{ $util.getFormatDate(campo.value) }}
                  </span>
                </div>
                <div :class="size_class" class="text-dark" v-else v-html="campo.value" style="white-space: pre-wrap;"></div>
              </div>
            </template>
            <template v-else>
              <div v-if="campo.type == 'rich'" :class="( ( !campo.label && !fullscreens[index] ) ? 'mt-1' : '' ) + ( fullscreens[index] ? ' panel-fullscreen' : '' )" >
                <div class="d-flex justify-content-between">
                    <small class="form-text text-muted" v-if="!isTable && campo.label && !fullscreens[index]">{{ campo.label }}</small>

                    <a href="#" @click.prevent="ver_textos(index, campo.value, campo, true)" class="card-link ml-2" v-if="1==0 && ( textos && textos.length )">
                        <i class="fa-solid fa-quote-left"></i>
                    </a>
                </div>

                <!-- EDITOR -->

                <div class="row no-gutters" :ref="'rich' + index" >
                  <div class="col col-12" :class="( textos && textos.length ) ? ( show_frases ? 'col-md-9' : 'col-md-11' ) : ''">
                    <az-editor
                      :ref="'htmleditor' + index"
                      :value="campo.value"
                      :textos="textos"
                      :form_campos="value"
                      :editorStyle="'height: ' + ( fullscreens[index] ? '86vh;' : get_height('rich' + index) )"
                      @input="autocompletar(index, campo, $event)"
                      @fullscreen="toggle_fullscreen_editor(index, campo)"
                      @quillativo="selquill"
                      :fullscreen="fullscreens[index] ? true : false" />
                  </div>
                  <div class="col col-12" :class="show_frases ? 'col-md-3' : 'col-md-1'" v-if="textos && textos.length">
                    <div style="height: 43px; background-color: #f4f4f4;">
                      <az-input
                            sizing="sm"
                            class="mt-0"
                            icon="fa fa-search"
                            placeholder="Pesquisar texto..."
                            v-model="pesquisar_texto">
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <button type="button" class="btn btn-outline-secondary" @click="show_frases = !show_frases">
                                        <i class="fa-solid fa-chevron-right" v-if="show_frases"></i>
                                        <i class="fa-solid fa-chevron-left" v-else></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>
                    </div>
                    <div class="card overflow-auto mb-0" style="padding: 0px;" :style="'height: ' + ( fullscreens[index] ? '100%;' : get_height('rich' + index) )">
                      <div class="card-body p-0">
                        <div v-if="lista_textos_campo(campo) && !lista_textos_campo(campo).length">
                          Nenhum texto identificado.
                        </div>

                        <div class="list-group">
                            <template v-for="(texto, itx) in lista_textos_campo(campo)">
                                <li class="list-group-item d-flex justify-content-between p-2" :key="itx" v-if="true">
                                    <div>
                                        <div>
                                            <a href="#" class="card-link"
                                                @click.prevent="frase_selecionada = texto; incluir_texto_modal({
                                                    index: index,
                                                    value: value,
                                                    campo: campo
                                                    });">
                                                <span class="small">{{ texto.st_titulo }}</span>
                                                <span class="badge badge-light ml-2" v-if="texto.st_atalho">{{ texto.st_atalho }}</span>
                                            </a>
                                        </div>
                                        <div v-if="texto.js_classes && texto.js_classes.length">
                                            <a href="#" @click.prevent="pesquisar_texto == '&quot;' + classe + '&quot;' ? pesquisar_texto = '' : pesquisar_texto = '&quot;' + classe + '&quot;'"
                                                v-for="(classe, icx) in texto.js_classes" :key="icx">
                                                <span class="badge badge-secondary ml-1">
                                                    {{ classe }}
                                                </span>
                                            </a>
                                        </div>
                                    </div>
                                    <div>
                                        <a href="#" @click.prevent="texto.fl_ativo = !texto.fl_ativo">
                                            <i class="fa fa-eye-slash fa-fw" aria-hidden="true" v-if="texto.fl_ativo"></i>
                                            <i class="fa fa-eye fa-fw" aria-hidden="true" v-else></i>
                                        </a>
                                    </div>
                                </li>

                                <li class="list-group-item alert-secondary small encurtar p-2" :key="'P' + itx" v-if="!texto.fl_ativo" style="padding: 0px;">
                                    <span v-html="texto.st_texto"></span>
                                </li>

                                <button type="button" class="list-group-item list-group-item-action p-2 d-flex justify-content-between" :key="'B' + itx" v-if="false"
                                    @click="frase_selecionada = texto; incluir_texto_modal({
                                    index: index,
                                    value: value,
                                    campo: campo
                                    });">
                                    <div>
                                        <span class="small">{{ texto.st_titulo }}</span>
                                        <span class="badge badge-light ml-2" v-if="texto.st_atalho">{{ texto.st_atalho }}</span>
                                        <div v-if="texto.js_classes && texto.js_classes.length">
                                            <a href="#" @click.prevent="pesquisar_texto == '&quot;' + classe + '&quot;' ? pesquisar_texto = '' : pesquisar_texto = '&quot;' + classe + '&quot;'"
                                                v-for="(classe, icx) in texto.js_classes" :key="icx">
                                                <span class="badge badge-secondary ml-1">
                                                    {{ classe }}
                                                </span>
                                            </a>
                                        </div>
                                    </div>
                                    <div>
                                        <a href="#" @click.prevent="texto.fl_ativo = !texto.fl_ativo">
                                            <i class="fa fa-eye-slash fa-fw" aria-hidden="true" v-if="texto.fl_ativo"></i>
                                            <i class="fa fa-eye fa-fw" aria-hidden="true" v-else></i>
                                        </a>
                                    </div>
                                </button>

                            </template>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- EDITOR -->

                <div class="card" v-if="fullscreens[index] && textos && textos.length" :class="( fullscreens[index] ? ' mb-0' : '' )">
                  <div class="card-footer p-2">
                    <az-input
                      sizing="sm"
                      type="autocomplete"
                      optionsMode="json"
                      :optionsList="textos"
                      :optionsSync="false"
                      icon="fa fa-plus"
                      v-model="novo_texto[index]"
                      @input="incluir_editor(index, campo.value, campo)">
                      <template v-slot:buttonposb>
                        <div class="input-group-append">
                          <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="ver_textos(index, campo.value, campo)">
                            <i class="fa-solid fa-magnifying-glass"></i>
                          </button>
                          <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="refresh_editor(campo, index)"
                            v-if="campo.value && ( campo.value.includes('#') || campo.value.includes('<code') )">
                            <i class="fas fa-sync-alt"></i>
                          </button>
                          <button type="button" class="btn btn-outline-secondary" @click="toggle_fullscreen_editor(index, campo)">
                            <i class="fas fa-expand" v-if="!fullscreens[index]"></i>
                            <i class="fas fa-compress" v-else></i>
                          </button>
                        </div>
                      </template>
                    </az-input>
                    <p v-if="false" class="alert alert-info">{{ campo.value }}</p>
                  </div>
                </div>
              </div>
              <template v-else-if="campo.type == 'number2'">
                <small class="form-text text-muted">{{ campo.label }}</small>
                <div class="input-group" :class="sizing == 'sm' ? 'input-group-sm' : ''">
                  <input type="number" class="form-control" :value="get_par_numero(campo, 0)" @input="set_par_numero(campo, 0, $event)">
                  <input type="number" class="form-control" :value="get_par_numero(campo, 1)" @input="set_par_numero(campo, 1, $event)">
                  <div class="input-group-append" v-if="campo.um">
                    <span class="input-group-text">
                      <small>{{ campo.um }}</small>
                    </span>
                  </div>
                </div>
              </template>
              <!-- Campo CID-11 -->
              <az-input
                placeholder="CID-11..."
                :compact="compact || campo.estilo == 'E'"
                :sizing="input_sizing"
                :label="campo.label"
                type="text"
                :required="campo.required"
                :validate="validate"
                v-model="campo.value"
                :rows="campo.rows"
                :mb="false"
                :textend="campo.um"
                v-else-if="campo.type == 'cid11'">
                <template v-slot:buttonposb>
                  <div class="input-group-append">
                    <button class="btn btn-outline-primary" type="button" id="button-addon2" @click="abrir_cid_11(campo)">
                      <i class="fa fa-search" aria-hidden="true"></i>
                    </button>
                  </div>
                </template>
              </az-input>

              <!-- :label="(!islist || !listindex) ? campo.label : ''" -->
              <az-input
                :compact="compact || campo.estilo == 'E'"
                :sizing="input_sizing"
                :label="( isTable && !( campo.type == 'checkbox-group' ) && !( campo.type == 'checkbox' && ( compact || campo.estilo == 'E' ) ) ) ? '' : campo.label"
                :type="( campo.type == 'checkbox' && ( compact || campo.estilo == 'E' ) ) ? 'checkbox-group' : campo.type"
                optionsData="id"
                optionsDisplay="search"
                optionsMode="json"
                :optionsList="lista(campo)"
                :service="'field' + index"
                :required="campo.required"
                :validate="validate"
                v-model="campo.value"
                change22.native="calc_computed ()"
                @input="calc_computed"
                :rows="campo.rows"
                :mb="false"
                :textend="campo.um"
                :edicao="audiograma_desabilita_ausencia(campo) && !campo.ne"
                :step="( campo.id && campo.id.slice(-2) == '-o' ) ? .25 : 1"
                v-else>
                <template v-slot:button-label>
                  <a href="#" @click.prevent="ver_textos(index, campo.value, campo, true)" class="card-link ml-2" v-if="( campo.type == 'textarea' ) && textos && textos.length">
                    <i class="fa-solid fa-quote-left"></i>
                  </a>

                  <span class="ml-2 text-muted" v-if="mode != 'view' && campo.pt" title="Ponto(s)">
                    ({{ campo.pt }})
                  </span>
                </template>
                <template v-slot:buttonposb>
                  <div class="input-group-append" v-if="campo.type == 'cid'">
                    <button class="btn btn-outline-primary" type="button" id="button-addon2" @click="buscar_cid(campo)">
                      <i class="fa fa-search" aria-hidden="true"></i>
                    </button>
                  </div>

                  <!-- Textos na visualização compacta -->
                  <div class="input-group-append" v-if="( compact || campo.estilo == 'E' ) && ( campo.type == 'textarea' && textos && textos.length )">
                    <button class="btn btn-outline-primary" @click="ver_textos(index, campo.value, campo, true)">
                      <i class="fa-solid fa-quote-left"></i>
                    </button>
                  </div>

                  <div class="input-group-append" v-else-if="campo.dd && campo.campos && campo.campos.length">
                    <template v-if="campo.campos[0].type == 'checkbox-group'">
                      <button class="btn btn-outline-secondary dropdown-toggle" tabindex="-1" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <template v-for="(opcao, iox) in campo.campos">
                          <span v-if="opcao.value" :key="iox" :title="opcao.label">
                            <i :class="opcao.icone" v-if="opcao.icone"></i>
                          </span>
                        </template>
                      </button>
                      <div class="dropdown-menu">
                        <a class="dropdown-item" href="#" @click.prevent="opcao.value = !opcao.value" v-for="(opcao, iox) in campo.campos" :key="iox">
                          <i :class="opcao.icone" class="fa-fw mr-2" v-if="opcao.icone"></i>
                          {{ opcao.label }}
                        </a>
                      </div>
                    </template>
                    <template v-else>
                      <button type="button" class="btn px-1" :class="opcao.value ? 'btn-secondary' : 'btn-outline-secondary'" v-for="(opcao, iox) in campo.campos" :key="iox" :title="opcao.label" @click="opcao.value = !opcao.value">
                        <i :class="opcao.icone" v-if="opcao.icone"></i>
                      </button>
                    </template>
                  </div>
                </template>
              </az-input>
              <div v-if="campo.ref" class="mb-2">
                <span class="small text-info">{{ campo.ref }}</span>
              </div>
            </template>
          </template>
          <!-- :speechable="true" -->

        </template>

      </div>
      </template>
    </div>

    <!-- Modal -->
    <div v-if="buscando_cid">
      <div class="modal fade" id="selecaoCidModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">CID</h5>
                <button type="button" class="close" @click="fechar_cid()" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
              <az-input
                ref="pesq_cid"
                placeholder="Pesquisar CID..."
                sizing="sm"
                type="autocomplete"
                optionsMode="aql"
                service="cids.index"
                optionsDisplay="search"
                v-model="novo_cid"
                @onEnter="selecionar_cid()" />

              <template v-if="novo_cid">

                <div class="input-group">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <input type="radio" name="info_cid" value="search" v-model="info_cid">
                    </div>
                  </div>
                  <label class="form-control">Código + Descrição</label>
                </div>

                <div class="input-group">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <input type="radio" name="info_cid" value="st_codigo" v-model="info_cid">
                    </div>
                  </div>
                  <label class="form-control">Código</label>
                </div>

                <div class="input-group">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <input type="radio" name="info_cid" value="st_cid" v-model="info_cid">
                    </div>
                  </div>
                  <label class="form-control">Descrição</label>
                </div>

              </template>

              <br><br><br><br><br><br><br><br><br><br><br>

              <pre v-if="false">{{ novo_cid }}</pre>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" @click="fechar_cid()">Fechar</button>
              <button type="button" class="btn btn-success" :disabled="!novo_cid" @click="selecionar_cid()">Selecionar</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <pre v-if="false">{{ value }}</pre>

    <!-- Modal Seleção Texto -->
    <div class="modal fade" :id="modal_textos" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Textos</h5>
            <button type="button" class="close" @click="fechar(modal_textos)" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" v-if="textos">
            <div class="row">
              <div class="col col-12 col-md-6">
                <az-input
                  sizing="sm"
                  icon="fa fa-search"
                  placeholder="Pesquisar texto..."
                  v-model="pesquisar_texto" />

                <div v-if="lista_textos && !lista_textos.length">
                  Nenhum texto identificado.
                </div>

                <div class="list-group">
                  <button type="button" class="list-group-item list-group-item-action" :class="( frase_selecionada && frase_selecionada.id_texto_padrao == texto.id_texto_padrao ) ? 'active' : ''" 
                    v-for="(texto, itx) in lista_textos" :key="itx" 
                    @click="frase_selecionada == texto ? incluir_texto_modal () : frase_selecionada = texto">

                    {{ texto.st_titulo }}

                    <div class="text-muted small" v-if="texto.st_atalho">{{ texto.st_atalho }}</div>

                  </button>
                </div>
              </div>
              <div class="col col-12 col-md-6">
                <div class="card" v-if="frase_selecionada">
                  <div class="card-header">
                    {{ frase_selecionada.st_titulo }}
                    <div class="text-muted small" v-if="frase_selecionada.st_atalho">{{ frase_selecionada.st_atalho }}</div>
                  </div>
                  <div class="card-body">
                    <span v-html="frase_selecionada.st_texto"></span>
                  </div>
                  <div class="card-footer" v-if="frase_selecionada.st_atalho">
                    <div class="small">
                      Digite /{{ frase_selecionada.st_atalho }}; para inserir este texto no campo.
                    </div>
                  </div>
                </div>

                <div v-else>
                  Selecione o texto desejado...
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="fechar(modal_textos)">Fechar</button>
            <button type="button" class="btn btn-success" v-if="frase_selecionada" @click="incluir_texto_modal()">Incluir</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from "../../shared/forms/AzInput.vue";
import AzSubTitle from "../../util/AzSubTitle.vue";
import Audiograma from '../../shared/Audiograma.vue';
import MarcadorImagem from '../../shared/gallery/MarcadorImagem.vue';
import AzEditor from '../../shared/forms/AzEditor.vue';
import ImitanciaAcustica from "../../shared/ImitanciaAcustica.vue";
import GraficoCrescimento from '../../shared/GraficoCrescimento.vue';

export default {
  name: "campos-formulario",
  data() {
    return {
      sizing: "sm",
      formulario: [],
      modelos: [],
      perfil: null,
      padrao: null,
      tipo_consulta_nome: "",
      fullscreens: [],
      fullscreen: false,
      novo_texto: [],
      buscando_cid: false,
      campo_cid: null,
      novo_cid: "",
      info_cid: "search",
      is_mounted: false,
      frase_selecionada: null,
      inclusao_de_texto: null,
      pesquisar_texto: "",
      tipo_lista_editor: 'T', 
      historico_pep: null, 
      quillativo: null, 
      show_frases: true, 
      estrutura: [
        {
          type: "title",
          label: "Dados Principais",
          width: "12"
        },
        {
          type: "textarea",
          width: "8",
          label: "Histórico Familiar",
          value: "abcde"
        },
        {
          type: "title",
          label: "Outras Informações",
          width: "12"
        },
        {
          type: "text",
          width: "4",
          label: "A"
        },
        {
          type: "text",
          width: "4",
          label: "B"
        },
        {
          type: "select",
          width: "4",
          label: "C",
          data: "id",
          display: "search",
          mode: "json",
          options: [
            { id: 1, search: "abc" },
            { id: 2, search: "def" }
          ]
        }
      ]
    };
  },

  components: {
    AzInput,
    AzSubTitle,
    Audiograma,
    MarcadorImagem,
    AzEditor,
    ImitanciaAcustica,
    GraficoCrescimento,
  },

  props: [
    "value",
    "saved",
    "mode",
    "modeloPadrao",
    "config",
    "tipo_consulta",
    "padrao_procedimento",
    "islist",
    "isTable",
    "listindex",
    "raiz",
    "printing",
    "compact",
    "textos",
    "secundario",
    "gutters",
    "tamanho",
    "tamanhoform",
    "validate",
    "onecol",
    "infopaciente",
    "eh_filho",
    "modelo", 
    "show_boxes", 
  ],

  computed: {
    size_class: function () {
      switch (this.tamanho) {
        case 'G': return 'lead';
        case 'M': return '';
        case 'P': return 'small';
      }

      return 'lead';
    },

    input_sizing: function() {
      if ( this.tamanhoform == 'g' ) {
        return "";
      }

      if ( this.tamanhoform == 'lg' ) {
        return "lg";
      }

      return "sm";
    },

    modal_textos: function() {
      return 'selecaoTextoModal' + this.uuidv4();
    },

    lista_textos: function () {
      let reg = this.$util.getregex(this.pesquisar_texto);

      return this.textos.filter(texto => !this.pesquisar_texto || reg.test(JSON.stringify(texto)))
        .filter(texto => !texto.fl_filtrar_campos
          || ( texto.js_lista_ids && texto.js_lista_ids.find(id => id == _.get(this.inclusao_de_texto, 'campo.id')) ) );
    },

    idade_meses: function () {
      if ( this.infopaciente && this.infopaciente.idade_meses ) {
        return this.infopaciente.idade_meses;
      }

      return 0;
    },

    sexo_paciente: function () {
      if ( this.infopaciente && this.infopaciente.sexo ) {
        return this.infopaciente.sexo;
      }

      return 'M';
    }

  },

  watch: {
    value: function(newValue) {
        this.$emit("input", newValue);
    },
  },

  methods: {
    selquill (quill) { 
      this.quillativo = quill;
    },

    toggle_view_grupo (grupo) { 
        if ( grupo.sh === false ) { 
            grupo.sh = true;
        } else { 
            grupo.sh = false;
        }

        this.$forceUpdate(); 
    },

    selec_tipo_lista_editor (tipo, index) { 

        this.tipo_lista_editor = tipo;

        this.$nextTick(() => { 
            let hist = this.$refs['pepm' + index];

            if ( hist && hist[0] ) { 
                hist[0].abrir(this.infopaciente.id_paciente);
            }
        });

    },

    // Score...

    total_pontos (campos, campo_base = null) { 

        let pontos = 0;
        let valores_pontos = {};

        let teste = campos.find (campo => { 
            return campo.value !== null 
                && campo.value !== undefined
                && campo.value !== ""
        }); 

        if ( !teste ) { 
            return null;
        }

        campos.forEach(campo => { 

            if ( !campo )
                return;

            let ponto = null;
            let aval = null;
            
            switch (campo.type) {
                case 'checkbox':
                case 'checkbox-group':
                    if ( campo.value ) { 
                        if ( campo.av_pt ) { 
                            ponto = parseInt(campo.av_pt);
                        } else if ( campo.av_pf ) { 
                            ponto = parseInt(campo.av_pf);
                        }
                    }
                    break;

                case 'number':
                case 'select':
                case 'radio-h':
                case 'radio-v':

                    if ( !campo.av ) { 
                        return;
                    }

                    aval = campo.av.find(item => {  

                        if ( item.tp == 'V' ) { 

                            if ( item.de <= campo.value && item.ate >= campo.value ) { 
                                return true;
                            }

                        } else if ( item.tp == 'T' ) { 

                            let opcoes = item.de.split(',');
                            opcoes = opcoes.map(op => op.trim().toUpperCase());

                            if ( campo.value && ( opcoes.find(op => op == campo.value.trim().toUpperCase()) ) ) { 
                                return true;
                            }
                            
                        }
                    }); 

                    if ( aval && aval.ponto ) { 
                        ponto = parseInt(aval.ponto);
                    }
                    break;

                /*
                case 'group':
                case 'tabela':
                    if ( data_get($campo, 'campos') ) {
                        $pontos += intval($this->total_pontos(data_get($campo, 'campos')));
                    }
                    break;
                */

            }

            campo.pt = ponto;
            if ( ponto ) { 
                pontos += ponto;
            }    
        });

        if ( campo_base && campo_base.av && campo_base.av.fc ) { 
            valores_pontos = _.cloneDeep(campos).map(item => { 
                item.value = item.pt ? item.pt : 0;
                return item;
            });

            let formula = this.replace_hashtags(campo_base.av.fc, false, valores_pontos);
            pontos = this.calc_formula(formula);
        } else { 
            if ( campo_base && campo_base.av && campo_base.av.fs && !isNaN(campo_base.av.fs) && campo_base.av.fs > 0 ) { 
                pontos = Math.round((pontos / parseFloat(campo_base.av.fs)) * 100) / 100;
            }
        }

        return pontos;

    },

    calc_score(campo) { 

      if ( !campo.score )
        return;

      let score = this.total_pontos(campo.campos, campo);
      let aval_final = null; 

      campo.sv = score;
      
      if ( campo.av && campo.av.js_avaliacao && campo.av.js_avaliacao.length ) { 

        let aval = campo.av.js_avaliacao.findIndex(item => {  

          if ( item.de <= score && item.ate >= score ) { 
              return true;
          }

        }); 

        if ( aval >= 0 ) { 
          aval_final = aval;
        }

      } 

      campo.aval = aval_final; 

      return score;

    },


    //
    lista_textos_campo(campo) {
        
        let reg = this.$util.getregex(this.pesquisar_texto);
        let lista = [
            _.get(campo, 'id')
        ];

        if ( this.modelo && this.modelo.js_classes && this.modelo.js_classes.length ) {
            lista = lista.concat(this.modelo.js_classes);
        }

        let retorno = this.textos.filter(texto => !this.pesquisar_texto || reg.test(JSON.stringify(texto)))
            .filter(texto => !texto.fl_filtrar_campos
            || !campo
            || ( texto.js_lista_ids && this.teste_intersect(texto.js_lista_ids, lista)) );

        if ( this.pesquisar_texto ) { 
            retorno = _.orderBy(retorno, 
                item => ( item && item.st_titulo && item.st_titulo.trim().toUpperCase() == this.pesquisar_texto.trim().toUpperCase() ) ? 0 : 1
            )
        }

        return retorno;

        // || ( texto.js_lista_ids && texto.js_lista_ids.find(id => id == _.get(campo, 'id')) ) );
    },

    teste_intersect (arr1, arr2) { 
        if ( !arr1 || !arr2 ) {
            return false;
        }

        const set2 = new Set(arr2);
        const existeIntersecao = arr1.some(item => set2.has(item));

        return existeIntersecao;
    },

    get_campo_em_valores(valores, id) {
      if ( !valores ) {
        return;
      }

      return valores.find(c => {
        return c.type != 'label' && c.id == id;
      });
    },

    grafico_valorY(campo) {

      const valores = this.valores(this.value);
      
      if(["1","2","3","4"].includes(campo.grafico)) {
        return  _.get(this.get_campo_em_valores(valores, 'altura'), 'value');
      } else if (["5", "6", "7", "8", "9", "10", "11"].includes(campo.grafico)) {
        return  _.get(this.get_campo_em_valores(valores, 'peso'), 'value');
      } else if (["12", "13", "14"].includes(campo.grafico)) {
        return  _.get(this.get_campo_em_valores(valores, 'imc'), 'value');
      } else if (["15", "16", "17"].includes(campo.grafico)) {
        return  _.get(this.get_campo_em_valores(valores, 'circ-cabeca'), 'value');
      } else if ("18" == campo.grafico) {
        return  _.get(this.get_campo_em_valores(valores, 'circ-braco'), 'value');
      } else if ("19" == campo.grafico) {
        return  _.get(this.get_campo_em_valores(valores, 'dobra-cut-subescapular'), 'value');
      } else if ("20" == campo.grafico) {
        return  _.get(this.get_campo_em_valores(valores, 'dobra-cut-triceps'), 'value');
      }
    },

    grafico_valorX(campo) {

      const valores = this.valores(this.value);

      if(["1","2","3","4","5", "6", "7", "8", "9","12", "13", "14", "16", "17", "18", "19", "20"].includes(campo.grafico)) {
        return this.idade_meses
      } else if (["10", "11"].includes(campo.grafico)) {
        return  _.get(this.get_campo_em_valores(valores, 'altura'), 'value');
      } else if (campo.grafico == '15') {
        return this.idade_meses*4.34524
      } 
    },

    grafico_crescimento () {
      const valores = this.valores(this.value);
      const valor = _.get(this.get_campo_em_valores(valores, 'altura'), 'value');
      return valor;
    },

    agrupa_linhas(campos, base = null) {
      let linhas = [];
      let linha = [];
      let tamanho = 0;
      let ind_col = 0;
      let colunas = [];

      if ( base && base.cols ) {
        colunas = base.cols.split(',');
      }

      if ( !campos ) {
        return [];
      }

      campos.forEach(campo => {

        tamanho = tamanho + parseInt(campo.width);

        if ( tamanho > 12 ) {
          linhas.push(linha);

          tamanho = parseInt(campo.width);
          ind_col = 0;
          linha = [];
        }

        linha.push({
          largura: Math.round( ( parseInt(campo.width) / 12 ) * 100 ),
          classes: ( colunas[ind_col] && colunas[ind_col].slice(0,1) == ' ' ) ? 'text-right' : '',
          cols: [campo]
        });

        ind_col ++;

      });

      if ( linha.length ) {
        linhas.push(linha);
      }

      return linhas;
    },

    get_height(name) {
      if ( ( this.value && this.value.length > 1 ) || this.eh_filho ) {
        return '320px';
      }

      return this.get_pos_y(name) < 300
        ? 'calc(100vh - '  + this.get_pos_y(name, 110) + 'px)'
        : '320px;'
    },

    get_pos_y(name, add = 0) {
      let item = this.$refs[name];

      if ( !item ) {
        console.log('Nada...', name);
        return '???';
      }

      if ( Array.isArray(item) ) {
        if ( !item.length ) {
          return;
        }

        item = item[0];
      }

      console.log(item);

      return item.getBoundingClientRect().top + add;
    },

    fechar(modal) {
      $('#' + modal).modal('hide');
    },

    uuidv4() {
        return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
    },

    ver_textos(index, value, campo, block_rich = false) {
        console.log('textos', this.textos);
        console.log('modal', this.modal_textos);

        this.inclusao_de_texto = {
            index: index,
            value: value,
            campo: campo,
            block_rich: block_rich, 
        };

        if ( !this.fullscreens[index] ) {
            $('#' + this.modal_textos).modal('show');
        }
    },

    htmltoText (html) {
      let text = html;
      text = text.replace(/\n/gi, "");
      text = text.replace(/<style([\s\S]*?)<\/style>/gi, "");
      text = text.replace(/<script([\s\S]*?)<\/script>/gi, "");
      text = text.replace(/<a.*?href="(.*?)[?"].*?>(.*?)<\/a.*?>/gi, " $2 $1 ");
      text = text.replace(/<\/div>/gi, "\n\n");
      text = text.replace(/<\/li>/gi, "\n");
      text = text.replace(/<li.*?>/gi, "  *  ");
      text = text.replace(/<\/ul>/gi, "\n\n");
      text = text.replace(/<\/p>/gi, "\n\n");
      text = text.replace(/<br\s*[/]?>/gi, "\n");
      text = text.replace(/<[^>]+>/gi, "");
      text = text.replace(/^\s*/gim, "");
      text = text.replace(/ ,/gi, ",");
      text = text.replace(/ +/gi, " ");
      // text = text.replace(/\n+/gi, "\n\n");
      return text;
    }, 

    incluir_texto_modal (info = null) {
      if ( info ) {
        this.inclusao_de_texto = info;
      }

      this.novo_texto[this.inclusao_de_texto.index] = this.frase_selecionada;
      this.fechar(this.modal_textos);

      this.$nextTick(() => {
        console.log('fs', this.frase_selecionada);

        if ( !this.inclusao_de_texto.block_rich ) { 
          this.incluir_editor(this.inclusao_de_texto.index, this.inclusao_de_texto.value, this.inclusao_de_texto.campo);
        } else { 
          let texto = this.frase_selecionada ? this.frase_selecionada.st_texto : '';

          if ( texto.indexOf('</') >= 0 && texto.indexOf('>') >= 0 ) { 
            texto = this.htmltoText(texto);
          }

          texto = this.replace_hashtags(texto);

          this.inclusao_de_texto.campo.value = texto;
        }
      });
    },

    selecionar_imagem_tool (campo, index) {
      campo.ms = index;
      this.$forceUpdate();
    },

    abrir_cid_11 (campo) {
      this.refw = window.open('/icd11.html', '_blank');
      //console.log(this.refw);

      setTimeout(() => {
        //console.log('Setiing CB...');

        if ( campo.value ) {
          this.refw.ECT.Handler.search('1', campo.value);
        }

        this.refw.set_cb(info => {
          campo.value = info.code;
          this.refw.close();
        });
      }, 1200);
    },

    grafico_audiograma(ouvido) {
      let info = [];

      if(ouvido == 'AO') {
        info = [
            {
            ouvido: 'direito', // direito | esquerdo
            tipo: "aerea", // aerea | ossea
            valores: this.dados_audiograma('direito', 'aerea'),
            },
            {
            ouvido: 'direito', // direito | esquerdo
            tipo: "ossea", // aerea | ossea
            valores: this.dados_audiograma('direito', 'ossea'),
            },
            {
            ouvido: 'esquerdo', // direito | esquerdo
            tipo: "aerea", // aerea | ossea
            valores: this.dados_audiograma('esquerdo', 'aerea'),
            },
            {
            ouvido: 'esquerdo', // direito | esquerdo
            tipo: "ossea", // aerea | ossea
            valores: this.dados_audiograma('esquerdo', 'ossea'),
            },
        ];
      } else if (ouvido == 'CL') {
        info = [
            {
            tipo: "livre", // aerea | ossea
            valores: this.dados_audiograma('livre', ''),
            },
        ];
      } else  {
        const ref = ( ouvido == 'OD' ) ? 'direito' : 'esquerdo';
        info = [
            {
            ouvido: ref, // direito | esquerdo
            tipo: "aerea", // aerea | ossea
            valores: this.dados_audiograma(ref, 'aerea'),
            },
            {
            ouvido: ref, // direito | esquerdo
            tipo: "ossea", // aerea | ossea
            valores: this.dados_audiograma(ref, 'ossea'),
            },
        ];
      } 

      return info;
    },

    dados_audiograma(ouvido, via) {
      let freqs = [250, 500, 1000, 2000, 3000, 4000, 6000, 8000];

        if (ouvido == 'livre') {
            return freqs.map(freq => {
                const id = 'cl' + '-' + freq;
                let valor = this.value.find(campo => campo.id == id);
                valor = valor && valor.value ? valor.value : null;

                return {
                    frequencia: freq,
                    valor: valor,
                }
            });
        } else {
            return freqs.map(freq => {
                const id = (ouvido == 'direito' ? 'od' : 'oe') + '-' + (via == 'aerea' ? 'va' : 'vo') + '-' + freq;
                let valor = this.value.find(campo => campo.id == id);

                const mascara = (valor && valor.dd && valor.campos && valor.campos.length)
                    ? valor.campos.find(campo => campo.id == id + '-m')
                    : this.value.find(campo => campo.id == id + '-m');

                const ausencia = (valor && valor.dd && valor.campos && valor.campos.length)
                    ? valor.campos.find(campo => campo.id == id + '-a')
                    : this.value.find(campo => campo.id == id + '-a');

                const valorAusencia = ausencia && ausencia.value ? true : false;

                if (valorAusencia && ausencia && ausencia.limite) {
                    valor = ausencia.limite;
                } else {
                    valor = valor && valor.value ? valor.value : null;
                }

                return {
                    frequencia: freq,
                    mascara: mascara && mascara.value ? true : false,
                    valor: valor,
                    ausente: valorAusencia,
                }
            });
            //.filter(freq => freq.valor !== null);
        }
    },

    audiograma_desabilita_ausencia(valor) {
        const ausencia =  ( valor && valor.dd && valor.campos && valor.campos.length )
            ? valor.campos.find(campo => campo.id == valor.id + '-a')
            : null;

        if(!ausencia) return true;

        return !ausencia.value;
    },

    grafico_imitancia() {

      const odAbre = this.value.find(campo => campo.id == 'od-abre');
      const odAbreA = this.value.find(campo => campo.id == 'od-abre-a');
      const odCompla = this.value.find(campo => campo.id == 'od-compla');
      const odPressao = this.value.find(campo => campo.id == 'od-pressao');
      const odFecha = this.value.find(campo => campo.id == 'od-fecha');
      const odFechaA = this.value.find(campo => campo.id == 'od-fecha-a');

      const oeAbre = this.value.find(campo => campo.id == 'oe-abre');
      const oeAbreA = this.value.find(campo => campo.id == 'oe-abre-a');
      const oeCompla = this.value.find(campo => campo.id == 'oe-compla');
      const oePressao = this.value.find(campo => campo.id == 'oe-pressao');
      const oeFecha = this.value.find(campo => campo.id == 'oe-fecha');
      const oeFechaA = this.value.find(campo => campo.id == 'oe-fecha-a');

      const info = [
        {
          ouvido: 'direito',
          valores: [
            {freq: odAbre ? odAbre.value : null, valor: odAbreA ? odAbreA.value : null},
            {freq: odPressao ? odPressao.value : null, valor: odCompla ? odCompla.value : null},
            {freq: odFecha ? odFecha.value : null, valor: odFechaA ? odFechaA.value : null},
          ],
        },
        {
          ouvido: 'esquerdo',
          valores: [
            {freq: oeAbre ? oeAbre.value : null, valor: oeAbreA ? oeAbreA.value : null},
            {freq: oePressao ? oePressao.value : null, valor: oeCompla ? oeCompla.value : null},
            {freq: oeFecha ? oeFecha.value : null, valor: oeFechaA ? oeFechaA.value : null},
          ],
        },
      ];

      return info;
    },

    selecionar_cid() {
      if ( !this.novo_cid )
        return;

      this.campo_cid.value = this.novo_cid[this.info_cid];
      this.fechar_cid();
    },

    fechar_cid() {
      $('#selecaoCidModal').modal('hide');
    },

    buscar_cid(campo) {
      this.campo_cid = campo;
      this.novo_cid = "";
      this.buscando_cid = true;

      this.$nextTick(() => {
        $('#selecaoCidModal').modal('show');

        this.$nextTick(() => {
          this.$refs.pesq_cid.$refs.input.focus ();
        });
      });
    },

    toggle_fullscreen_editor (index, campo = null) {
      this.fullscreens[index] = !this.fullscreens[index];
      this.$forceUpdate();

      if ( campo && this.fullscreens[index] ) {
        this.ver_textos(index, campo.value, campo);
      }
    },

    get_par_numero (campo, indice) {
      let partes = campo.value ? campo.value.split('|') : "|";

      if ( partes.length != 2 ) {
        partes = ["", ""];
      }

      return partes[indice];
    },

    set_par_numero (campo, indice, valor) {
      valor = valor.target.value;

      let partes = campo.value ? campo.value.split('|') : "|";

      if ( partes.length != 2 ) {
        partes = ["", ""];
      }

      partes[indice] = valor;

      campo.value = partes.join('|');
    },

    refresh_editor(campo) {
      campo.value = this.replace_hashtags(campo.value, true);
      // this.replace_hashtags(campo.value, index, true);

      this.$nextTick(() => {
        this.$emit("input", this.value);
      });
    },

    incluir_editor(index, base, campo = null) {
      if ( !this.novo_texto[index] )
        return;

      /*
      let texto = this.replace_hashtags(
        this.novo_texto[index].st_texto
      );
      */

      let texto = this.novo_texto[index].st_texto;

      // Substituição de hashtags
      texto = this.replace_hashtags(texto, true);
      //

      this.novo_texto[index] = null;

      const quill = this.$refs['htmleditor' + index][0].quill;

      if ( !quill.hasFocus() ) {
        quill.focus();
      }

      let posic = quill.getSelection();

      if ( !posic ) {
        console.log('sem posic');
        quill.focus();
        posic = quill.getSelection();
      }

      console.log(posic);
      console.log(base);
      console.log('quill', quill);
      console.log('quill hf', quill.hasFocus());

      if ( posic && posic.index > 0 ) {
        quill.clipboard.dangerouslyPasteHTML(posic.index, texto);
      } else {
        quill.clipboard.dangerouslyPasteHTML(0, texto);
        // quill.clipboard.dangerouslyPasteHTML( ( base && base.value ) ? ( base.value + texto ) : texto);
      }

      this.$nextTick(() => {
        this.novo_texto[index] = "";
        this.$forceUpdate();

        if ( campo ) {
          this.refresh_editor(campo, index);
        }
      });
    },

    autocompletar(index, campo, event) {
      if ( campo.value != event ) {
        if ( this.is_mounted ) {
          campo.value = event;
          this.$set(this.value, index, campo);
        }
        // console.log('ALTERADO!!!', this.value, this.is_mounted);
      } else {
        // console.log('IGUAL!!!');
      }

      //console.log(campo, event);

      let busca;

      if ( window.redir == 'teste' || window.redir == 'labstudart' ) { 
        busca = /@([A-Za-z0-9])\w+;/g.exec(campo.value);
      } else { 
        busca = /\/([A-Za-z0-9])\w+;/g.exec(campo.value);
      }

      if ( busca && busca.length > 0 ) {
        this.$nextTick(() => {
          let texto = this.textos.find(item => item.st_atalho.toUpperCase() == busca[0].substr(1,busca[0].length - 2).toUpperCase());
          let novo_texto = ( texto ? texto.st_texto : '' );

          if ( novo_texto.slice(0,3) == '<p>' && novo_texto.slice(-4) == '</p>' ) { 
            novo_texto = novo_texto.slice(3, -4);
          }

          campo.value = campo.value.replace(busca[0], novo_texto);

          const quill = this.$refs['htmleditor' + index][0].quill;
          let posic = quill.getSelection().index;

          this.refresh_editor(campo, index);

          quill.clipboard.dangerouslyPasteHTML(campo.value);
          quill.setSelection (posic - busca[0].length, 0);

          this.$nextTick(() => {
            //console.log('Refresh', campo, index);
          });
        });

      }
    },
    nl2br (str, is_xhtml = false) {
        if (typeof str === 'undefined' || str === null) {
            return '';
        }
        str = str.replace(/[\u00A0-\u9999<>]/gim, function(i) {
          return '&#' + i.charCodeAt(0) + ';';
        });
        var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
        return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    },

    tem_valor(campos) {

      if ( !campos )
          return false;

      if ( this.modelo && this.modelo.fl_view_vazio )
        return true;

      let valores = campos;

      valores = valores.flatMap(x => ( ( x.type == 'group' || x.type == 'tabela' ) && x.campos ) ? x.campos : x);
      valores = valores.flatMap(x => ( ( x.type == 'group' || x.type == 'tabela' ) && x.campos ) ? x.campos : x);
      valores = valores.flatMap(x => ( ( x.type == 'group' || x.type == 'tabela' ) && x.campos ) ? x.campos : x);

      return valores.findIndex(item => item.value || ( item.lista && item.lista.length ) ) >= 0;

    },

    valores(campos) {

      if ( !campos )
          return false;

      let valores = campos;

      valores = valores.flatMap(x => ( ( x.type == 'group' || x.type == 'tabela' ) && x.campos ) ? x.campos : x);
      valores = valores.flatMap(x => ( ( x.type == 'group' || x.type == 'tabela' ) && x.campos ) ? x.campos : x);
      valores = valores.flatMap(x => ( ( x.type == 'group' || x.type == 'tabela' ) && x.campos ) ? x.campos : x);

      return valores;

    },

    lista(campo) {
      let lista = [];

      if ( ( campo.type == "select" || campo.type == "radio-h" || campo.type == "radio-v" ) && campo.options ) {
        lista = campo.options.split(",").map(item => {
          return { id: item.trim(), search: item.trim() };
        });
      }

      return lista;
    },

    visivel(campo) {
      if ( !campo.v )
        return true;

      let calc = this.replace_hashtags(campo.v, false, null, true);

      if (calc) {
        try {
          //console.log(1, campo, calc);
          let valor = Function('"use strict";return (' + calc + ")")();
          //console.log('visivel', campo, calc, valor);
          return valor;
        } catch (e) {
          //console.log(3, 'errorvis', e);
          return false;
        }
      }

      return false;
    },

    calc_formula(calc) { 

        try {
              if ( calc.indexOf('#') >= 0 ) {

                return 'Fórmula com #: ' + calc;
              } else {
                let valor = Function('"use strict";return (' + calc + ")")();
                return valor;
              }
        } catch (e) {
            if (e instanceof SyntaxError) {
                return e.message;
            } else { 
                return '';
            }
        }

    },

    calc_computed() {

      let valores = this.valores(this.value);
      this.$emit('recalc');

      valores.forEach((campo, index) => {
        if (campo.type == "computed") {
          //console.log('calc campo', campo);
          let calc = this.replace_hashtags(campo.expression);
          if (calc) {
            //console.log('calc formula', calc);
            try {
              if ( calc.indexOf('#') >= 0 ) {
                console.error('Fórmula com #', calc);
              } else {
                let valor = Function('"use strict";return (' + calc + ")")();

                //console.log('valor', valor);

                if (campo.precision == 2 && campo.id && campo.id.slice(-2) == '-o' ) {

                  campo.value = ( valor > 0 ? '+' : '' ) + this.$util.formatNumber(valor, 2);

                } else if (campo.precision) {

                  let formatter = new Intl.NumberFormat("pt-Br", {
                    style: "decimal",
                    maximumFractionDigits: campo.precision
                  });

                  campo.value = formatter.format(valor);

                } else {

                  campo.value = valor;

                }
              }
            } catch (e) {
              campo.value = "";
              if (e instanceof SyntaxError) {
                campo.value = e.message;
                //console.log(e.message);
              }
            }
          }
          return;
        }

        if ( campo.type == 'rich' ) {
          this.$nextTick(() => {
            this.refresh_editor(campo, index);
          });
        }
      });
    },

    replace_hashtags(expression, rich = false, base_valores = null) {
      //var regex = /(?:^|\s)(?:#)([a-zA-Z\d]+)/gm;
      var regex = /(?:#)([a-zA-Z_\-|\d]+)/gm;
      var matches = [];
      var match;

      let valores = this.valores(base_valores ? base_valores : this.value);

      while ((match = regex.exec(expression))) {
        matches.push(match[1]);
      }

      matches.forEach(hash => {

        let hash_id = ( hash.indexOf('|') > 0 ) ? hash.split('|')[0] : hash;

        let campo = valores.find(c => {
          return c.type != 'label' && c.id == hash_id;
        });

        if ( !campo && hash == 'sexo' ) {
          const sexo = _.get(this.infopaciente, 'sexo', 'T');

          expression = expression.replace(
            "#" + hash,
            "'" + sexo + "'"
          );
        }

        if (campo) {

          let newvalue = ( ( campo.value && typeof campo.value == 'string' ) ? campo.value.replace(',', '.') : campo.value );

          if ( rich ) {
            if ( !newvalue ) {
              newvalue = '&nbsp;';
            }

            if ( newvalue && (typeof newvalue == 'string') && newvalue.indexOf('<code') >= 0 ) { 
              newvalue = "...";
            } else { 
                newvalue = '<code class="ql-campo" id="' + campo.id + '">' + newvalue + '</code>';
            }
          } else if ( !newvalue && newvalue !== 0 && campo.type == 'number' ) {
            if ( hash.indexOf('|') > 0 ) { 
              newvalue = _.get(hash.split('|'), '1');
            } else {
              expression = "''";
            }
          }

          if ( newvalue && newvalue !== true && !isNaN(newvalue) ) {
            newvalue = parseFloat(newvalue);
          }

          /*
          ( false && quotes && typeof newvalue === 'string' ) 
                ? ( newvalue ? "'" + newvalue + "'" : "''" ) 
                : newvalue
            */

          expression = expression.replace(
            "#" + hash,
            newvalue
          );
        }
      });

      if ( rich ) {

        let temp = document.createElement('div'); // Create a temporary element
        temp.innerHTML = expression; // Set the passed string as HTML to the temporary element
        let campos = temp.getElementsByClassName('ql-campo'); // Find an element with the passed id

        if ( campos.length > 10000 ) {
          console.error('Muitos campos na expressão:', expression);
          return expression;
        }

        _.each(campos, item => {

            // item.setAttribute('contenteditable', false);

            let campo = valores.find(c => {
                return c.id == item.id;
            });

            if (campo) {
                let valor = campo.value;

                if ( campo.type == 'number' && typeof valor == 'string' ) {
                    valor = valor.replace('.', ',');
                }

                if ( valor && ( typeof valor == 'string' ) ) { 
                    if ( valor.includes('<code') || valor.includes('#') || valor.includes('</') ) { 
                        console.log('Campo inválido...', campo.id, valor);
                        return;  
                    }
                }

                item.innerHTML = valor ? valor : '&nbsp;';
            }

        });

        expression = temp.innerHTML;

      }

      return expression;
    },

    excluirItem(lista, index) {
      lista.splice(index, 1);
    },

    incluirItemLista(campo) {
      if ( !campo.lista )
        campo.lista = [];

      campo.lista.push(_.cloneDeep(campo.campos));

      this.$forceUpdate();
    }

  },

  beforeCreate() {
    /*
    // Import Block (I think it's from parchment)
    let Block = Quill.import('blots/block');

    // Create a custom blot for Javascript
    class CampoBlot extends Block {
      static create(value) {
        console.log('campo', value);
        let node = super.create(value);
        node.innerText = value;
        // Attribute for output HTML
        node.setAttribute('class', 'ql-syntax teste-abc');
        return node;
      }
    }

    CampoBlot.blotName = 'campo2';
    // Class to look for when parsing your input HTML
    CampoBlot.className = 'ql-campo';
    // Tag to look for when parsing your input HTML
    CampoBlot.tagName = 'code';
    // Register your custom blot with quill.
    Quill.register(CampoBlot);
    */
    //

    /* FInal...
    let Inline = Quill.import('blots/inline');

    class CampoIdBlot extends Inline {
      static create(value) {
        const node = super.create();
        node.setAttribute('id', value.id);
        return node;
      }

      static formats(domNode) {
        return domNode;
      }

      static value(domNode) {
        return {
          id: domNode.dataset.id,
          url: domNode.dataset.url,
          html: domNode.dataset.html,
          type: domNode.dataset.type,
        };
      }
    }
    CampoIdBlot.blotName = 'campo';
    CampoIdBlot.tagName = 'code';
    CampoIdBlot.className = 'ql-campo';
    Quill.register(CampoIdBlot);
    */

  },

  mounted () {
    this.is_mounted = true;
  }

};
</script>

<style>
.panel-fullscreen {
  display: block;
  z-index: 999999;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  overflow: auto;
}

.encurtar p {
  margin-bottom: 0px !important;
}

/* Ajuste do Qull */
.quill-content li[data-list="bullet"] {
  list-style-type: disc;
}
</style>
